import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { StyledDBVatInstructions } from './VatBreakdown.styles';

const DBVatInstructions = ({ intl }) => (
  <StyledDBVatInstructions data-cy="db-vat-instructions">
    <strong>
      <FormattedMessage id="receipt.dbVat.title" />
    </strong>
    <FormattedMessage id="receipt.dbVat.intro" tagName="p" />
    <ol>
      <li>
        <FormattedMessage
          id="receipt.dbVat.visit"
          values={{
            link: (
              <a href={intl.formatMessage({ id: 'receipt.dbVat.url' })} target="_blank" rel="noreferrer">
                {intl.formatMessage({ id: 'receipt.dbVat.url' })}
              </a>
            )
          }}
        />
      </li>
      <li>
        <FormattedMessage id="receipt.dbVat.enterDetails" />
      </li>
      <li>
        <FormattedMessage id="receipt.dbVat.createInvoice" />
      </li>
    </ol>
  </StyledDBVatInstructions>
);

DBVatInstructions.propTypes = {
  intl: intlShape.isRequired
};

export default injectIntl(DBVatInstructions);
